import { createPlugin } from "../../utils/plugin";
import reducer from "./reducer";
import view from "./view";

// hur få den att kunna ha fler knappar

interface IOptionalProps {
  openButtonClass?: string;
  closedButtonClass?: string;
  contentId?: string;
}

export interface IDropDownProps extends IOptionalProps {
  el: HTMLElement;
  closedClass?: string;
  buttonSelector?: string;
}

interface IDropDownDefaultProps extends IOptionalProps {
  closedClass: string;
  buttonSelector: string;
  isClosed: boolean;
}

export interface IDropDownModel extends IDropDownDefaultProps {
  el: HTMLElement;
}

type DropDown = (props: IDropDownProps) => void;

const DEFAULT_PROPS: IDropDownDefaultProps = {
  buttonSelector: ".js-dropDown__button",
  closedClass: "-isClosed",
  isClosed: true,
};

const DropDown = createPlugin(DEFAULT_PROPS, view, reducer) as DropDown;

export default DropDown;
